// extracted by mini-css-extract-plugin
export default {"header-container":"modal-header_header-container__b3loH"};